<template>
  <div class="redeemPop" @click="submit" ref="popPage">
        <div class="redeemBox" @click.stop>
           <div class="textArea">
               <p class="text1">Error</p>
               <p class="text2">{{errMess}}</p>
               
           </div>
           <div class="clickArea">
               <div class="btn1" @click="submit">OK</div>
           </div>
        </div>
     </div>
</template>

<script>
export default {
  name: 'ErrorPop',
  props:{
      errdata: "",
  },
  data () {
    return {
     errMess:'',
    }
  },
  mounted(){
    this.errMess = this.errdata;
  },
  methods:{
      submit(){
          event.stopPropagation();
         this.$emit('submit');
      }
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .redeemPop{
    width: 100%;
    height: 100vh;
    background: rgb(124,124,124);
    position: absolute;
    left: 0;
    top:0;
    z-index: 4;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family:  Roboto, Helvetica, sans-serif;
}
.redeemBox{
    width: 2.7rem;
    /* height: 1.6rem; */
    background: rgb(230,230,230);
    border-radius: 0.14rem;
    margin-top: 40%;
}
.textArea{
   width: 2.4rem;
   margin: 0.2rem 0.15rem 0.15rem 0.15rem;
   /* background: yellow; */
}
.text1{
   line-height: 0.2rem;
   font-size: 0.16rem;
   font-weight: bolder;
   color: #000;
   text-align: center;
}
.text2{
   line-height: 0.18rem;
   font-size: 0.12rem;
   font-weight: bolder;
   color: rgb(99,99,101);
   text-align: center;
   margin: 0.1rem 0;
}
.inputId{
    width: 2.4rem;
    height: 0.36rem;
    line-height: 0.36rem;
    text-align: center;
    font-size: 0.16rem;
    color: rgb(142,142,147);
    background: rgba(142,142,147,0.12);
    border-radius: 0.1rem;
}
.clickArea{
   width: 100%;
   height: 0.55rem;
   border-top: 1px solid rgb(124,124,124);
   display: flex;
   justify-content: space-between;
}
.btn1{
   width: 100%;
   height: 0.55rem;
   text-align: center;
   line-height: 0.55rem;
   color: rgb(236,41,121);
   font-size: 0.16rem;
}
.border{
  width: 1px;
  height: 0.55rem;
  background: rgb(124,124,124);
}
</style>


// WEBPACK FOOTER //
// src/components/ErrorPop.vue